export interface Unit {
  id: string;
  name: string;
  symbol: string;
  parentId: string | null;
  parentName: string | null;
  conversionRatio: number; // How many of this unit equals 1 parent unit
  category: string; // e.g., 'Weight', 'Length', 'Volume', 'Quantity'
}

export const DEFAULT_UNITS: Unit[] = [
  // Quantity units
  { id: 'piece', name: 'Piece', symbol: 'pc', parentId: null, parentName: null, conversionRatio: 1, category: 'Quantity' },
  { id: 'unit', name: 'Unit', symbol: 'unit', parentId: null, parentName: null, conversionRatio: 1, category: 'Quantity' },
  { id: 'dozen', name: 'Dozen', symbol: 'dz', parentId: 'unit', parentName: 'Unit', conversionRatio: 12, category: 'Quantity' },
  { id: 'pair', name: 'Pair', symbol: 'pr', parentId: 'unit', parentName: 'Unit', conversionRatio: 2, category: 'Quantity' },
  { id: 'box', name: 'Box', symbol: 'box', parentId: 'unit', parentName: 'Unit', conversionRatio: 24, category: 'Quantity' },
  { id: 'case', name: 'Case', symbol: 'cs', parentId: 'box', parentName: 'Box', conversionRatio: 12, category: 'Quantity' },
  { id: 'pallet', name: 'Pallet', symbol: 'plt', parentId: 'case', parentName: 'Case', conversionRatio: 48, category: 'Quantity' },
  
  // Weight units
  { id: 'gram', name: 'Gram', symbol: 'g', parentId: null, parentName: null, conversionRatio: 1, category: 'Weight' },
  { id: 'kilogram', name: 'Kilogram', symbol: 'kg', parentId: 'gram', parentName: 'Gram', conversionRatio: 1000, category: 'Weight' },
  { id: 'pound', name: 'Pound', symbol: 'lb', parentId: 'gram', parentName: 'Gram', conversionRatio: 453.592, category: 'Weight' },
  { id: 'ounce', name: 'Ounce', symbol: 'oz', parentId: 'gram', parentName: 'Gram', conversionRatio: 28.3495, category: 'Weight' },
  { id: 'ton', name: 'Ton', symbol: 't', parentId: 'kilogram', parentName: 'Kilogram', conversionRatio: 1000, category: 'Weight' },
  
  // Length units
  { id: 'meter', name: 'Meter', symbol: 'm', parentId: null, parentName: null, conversionRatio: 1, category: 'Length' },
  { id: 'centimeter', name: 'Centimeter', symbol: 'cm', parentId: 'meter', parentName: 'Meter', conversionRatio: 0.01, category: 'Length' },
  { id: 'foot', name: 'Foot', symbol: 'ft', parentId: 'meter', parentName: 'Meter', conversionRatio: 0.3048, category: 'Length' },
  { id: 'inch', name: 'Inch', symbol: 'in', parentId: 'foot', parentName: 'Foot', conversionRatio: 0.0833, category: 'Length' },
  
  // Volume units
  { id: 'liter', name: 'Liter', symbol: 'L', parentId: null, parentName: null, conversionRatio: 1, category: 'Volume' },
  { id: 'milliliter', name: 'Milliliter', symbol: 'mL', parentId: 'liter', parentName: 'Liter', conversionRatio: 0.001, category: 'Volume' },
  { id: 'gallon', name: 'Gallon', symbol: 'gal', parentId: 'liter', parentName: 'Liter', conversionRatio: 3.78541, category: 'Volume' },
];

export const UNIT_CATEGORIES = ['Quantity', 'Weight', 'Length', 'Volume', 'Area', 'Time', 'Other'];

